import { StoreStateSelector } from './common';

/**
 * Basic selectors
 */

export const getDisplayTime: StoreStateSelector<Date> = (store) => store.timeStore.displayTime;
